<template>
  <div
  :class="textColor"
    class="d-flex text-size-18 justify-content-end align-items-center text-weight-semi-bold"
  >
    <div class="mr-2 my-2 text-center">
      <div class="text-size-24 line-height">
        <font-awesome-icon
          :icon="['fal', 'eye-slash']"
        />
        <span v-if="!isOwner" class="ml-2 text-size-14">{{ msg }}</span>
      </div>
      <div v-if="isOwner" class="text-size-10">
         {{ $t('options.hiddenPoll') }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'RendererHiddenModeParticipantMobile',
  props: ['adminName', 'isOwner', 'isDarkMode', 'type'],

  computed: {
    msg() {
      console.log('this.type -->', this.type);
      return this.$t('options.hiddenPollParticipantTip', 
        {pollType : this.type, organizerName : this.adminName});
    },

    textColor () {
        if( this.isDarkMode ) return 'text-dark-mode';
        return 'text-light-mode';
    }
  },
};
</script>
<style scoped lang="scss">

.line-height {
  line-height: 16px;
}
.mr-2.my-2.text-center {
  max-width: 500px;
  word-break: break-word;
}

</style>